export default [
  {
    path: '',
    name: 'stock adjustment list',
    component: () => import('@/views/app/stock-adjustment/page-list.vue'),
    meta: { title: 'Riwayat Penyesuaian Stok' },
  },
  {
    path: 'create',
    name: 'stock adjustment create',
    component: () => import('@/views/app/stock-adjustment/page-create.vue'),
    meta: { title: 'Buat Penyesuaian Stok' },
  },
  {
    path: ':id',
    name: 'stock adjustment detail',
    component: () => import('@/views/app/stock-adjustment/page-detail.vue'),
    meta: { title: 'Detail Penyesuaian Stok' },
  },
]
